import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientServiceProfile } from '@models/profileConfiguration/model';
import { ContactQuery } from '@app/state';
import { ServiceFactory } from './service.factory';
import { stringFormat } from '@brycemarshall/string-format';
import { CommonConstants } from '../constants/common.constant';

@Injectable({
  providedIn: 'root',
})
export class ClientServiceProfileService {
  private contactQuery = inject(ContactQuery);
  private serviceFactory = inject(ServiceFactory);

  public getClientServiceProfile(): Observable<ClientServiceProfile[]> {
    const clientId = this.contactQuery.getActive().clientId;
    const basePath = stringFormat(CommonConstants.getPath.profile.getClientServiceProfile, {
      profileId: clientId,
    });

    return this.serviceFactory.query(CommonConstants.getPath.profile.configurationKey, basePath);
  }
}
